import React from 'react';
import {Card, CardText} from 'material-ui/Card';
import { ViewTitle } from 'admin-on-rest/lib/mui';
import {dashStyles} from './shared/styles-dashboard';
import HelpIcon from 'material-ui/svg-icons/action/help';

export default () => (
    <div>
        <Card style={{...dashStyles.dash, ...dashStyles.marginBottom}}>
            <HelpIcon style={dashStyles.dashIcon}/>
            <ViewTitle title="Not Found"/>
            <CardText>
                Sorry, that page was not found.
            </CardText>
        </Card>
    </div>
);



// WEBPACK FOOTER //
// ./src/Fuse/notFound.js